import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import Welcome from './screens/Welcome';
import Tool from './screens/Tool';
import { View, Platform } from 'react-native';
import { Icon, Text } from 'react-native-elements';
import FirebaseContext from './components/FirebaseContext';
import { Menu, MenuTrigger, MenuOptions, MenuOption, renderers } from 'react-native-popup-menu';
import Project from './screens/Project';
import { scale } from 'react-native-size-matters';

export type AgentStackParamList = {
	Welcome: undefined;
	Project: { docId: string };
	Tool: { docId: string; project: string };
	Profile: undefined;
};

const Stack = createStackNavigator<AgentStackParamList>();

export default function AgentStack(): JSX.Element {
	return (
		<Stack.Navigator>
			<Stack.Screen
				name="Welcome"
				component={Welcome}
				options={{
					title: 'LASHMA QAPro - Home',
					headerStyle: { elevation: 0 },
					headerTitleStyle: { fontSize: scale(16) },
					headerRight: More,
				}}
			/>
			<Stack.Screen
				name="Project"
				component={Project}
				options={{
					title: 'LASHMA QAPro - Project',
					headerStyle: { elevation: 0 },
					headerTitleStyle: { fontSize: scale(16) },
					headerRight: More,
				}}
			/>
			<Stack.Screen
				name="Tool"
				component={Tool}
				options={{
					title: 'LASHMA QAPro - Tool',
					headerStyle: { elevation: 0 },
					headerTitleStyle: { fontSize: scale(16) },
					headerRight: More,
				}}
			/>
		</Stack.Navigator>
	);
}

function More() {
	return (
		<View style={{ flexDirection: 'row', right: 20 }}>
			<Menu renderer={renderers.Popover} rendererProps={{ preferredPlacement: 'bottom', placement: 'bottom' }}>
				<MenuTrigger>
					<Icon name={Platform.OS == 'android' ? 'more-vertical' : 'more-horizontal'} type="feather" />
				</MenuTrigger>
				<MenuOptions customStyles={{ optionsWrapper: { padding: 10 } }}>
					<MenuOption customStyles={{ optionWrapper: { flexDirection: 'row' } }}>
						<Icon name="user" type="feather" size={20} style={{ alignSelf: 'center' }} />
						<Text style={{ fontSize: 18 }}>&nbsp;Profile</Text>
					</MenuOption>
					<MenuOption
						onSelect={() => {
							FirebaseContext.auth().signOut();
						}}
						customStyles={{ optionWrapper: { flexDirection: 'row' } }}
					>
						<Icon name="log-out" type="feather" size={20} style={{ alignSelf: 'center' }} />
						<Text style={{ fontSize: 18 }}>&nbsp;Logout</Text>
					</MenuOption>
				</MenuOptions>
			</Menu>
		</View>
	);
}
